// extracted by mini-css-extract-plugin
module.exports = {"image":"signUp_image__2k0JN","title":"signUp_title__3Attf","text":"signUp_text__YF4s7","input":"signUp_input__zQn_8","inputBlock":"signUp_inputBlock__19yai","label":"signUp_label__Q3cNk","dialog":"signUp_dialog__3fbEd","subText":"signUp_subText__3cvOr","agree":"signUp_agree__2bmWQ","forgot":"signUp_forgot__1P4j-","firstRowForm":"signUp_firstRowForm__2J8-t"};
    if(module.hot) {
      // 1783591920054
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  